import React from 'react';
import styled from '@emotion/styled';
import { StandardContentBlock } from '../../components/StandardContentBlock/StandardContentBlock';
import RichText from '../../util/RichText';
import getBackgroundColor from '../../util/getBackgroundColor';
import { EmotionBreakpoint } from 'dw-us-ui';

const ContentBlockSection = styled.section`
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ fontColor }) => fontColor};
  padding: 2rem 0;
  text-align: left;
  .content-block-section {
    margin-left: auto;
    margin-right: auto;
    padding-left: 15px;
    padding-right: 15px;
    ${EmotionBreakpoint('desktop')} {
      max-width: 970px;
    }
    ${EmotionBreakpoint('tablet')} {
      max-width: 720px;
    }
    @media (min-width: 576px) and (max-width: 768px) {
      max-width: 540px;
    }
  }
  .content-block-title {
    margin-bottom: 1.5rem;
    font-size: 28px;
    font-weight: bold;
  }
  ul {
    list-style: unset;
    margin-bottom: 1rem;
    padding-inline-start: 40px;
  }
  p {
    margin-bottom: 1rem;
  }
  p:last-child {
    margin-bottom: 0;
  }
  h2 {
    font-size: 1.6rem;
  }
`;

const StandardContentBlockWrapper = ({ fields }) => {
  const bgColor = getBackgroundColor(fields?.backgroundColor);
  const content =
    fields?.blocks && fields?.blocks[0]?.fields?.content
      ? RichText(fields?.blocks[0]?.fields?.content)
      : fields?.content
      ? RichText(fields?.content)
      : null;
  const mobContent =
    fields?.blocks && fields?.blocks[0]?.fields?.mobileContent
      ? RichText(fields?.blocks[0]?.fields?.mobileContent)
      : fields?.mobileContent
      ? RichText(fields?.mobileContent)
      : null;

  const heading =
    fields?.blocks && fields?.blocks[0]?.fields?.title
      ? fields?.blocks[0]?.fields?.title
      : fields?.title
      ? fields?.title
      : null;
  const mobHeading =
    fields?.blocks && fields?.blocks[0]?.fields?.mobileTitle
      ? fields?.blocks[0]?.fields?.mobileTitle
      : fields?.mobileTitle
      ? fields?.mobileTitle
      : null;

  return (
    <ContentBlockSection data-testid="content-block" bgColor={bgColor} fontColor={fields?.fontColor || '#000'}>
      <div className="content-block-section">
        <StandardContentBlock
          heading={heading}
          content={content}
          mobContent={mobContent}
          mobHeading={mobHeading}
        ></StandardContentBlock>
      </div>
    </ContentBlockSection>
  );
};

export { StandardContentBlockWrapper };
